import React from 'react'
import Icon from './../static/icon'

import styles from './buttonControls.module.scss'

const ButtonControls = props => {
  const { handleClick, icon, disabled } = props

  return (
    <button className={styles.buttonControls} onClick={handleClick} disabled={disabled}>
      <span className={styles.icon}>
        <Icon name={icon} />
      </span>
    </button>
  )
}

export default React.memo(ButtonControls)